import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';
import { TooltipDirective } from '@ui';

@Component({
  selector: 'ui-phase-intensity-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, TranslocoDecimalPipe],
  template: `
    <div class="border border-gray-200 p-1 rounded-full">
      <div class="w-full rounded-full h-4 relative overflow-hidden">
        @for (phase of phases(); track phase.label) {
          <div
            uiTooltip
            [tooltipTitle]="tooltipTitleTemplate"
            [tooltipTitleContext]="{ $implicit: phase }"
          >
            <div
              class="absolute top-0 h-full"
              [class]="phase.bgClass"
              [style.width.%]="phase.width"
              [style.left.%]="phase.left"
            ></div>
          </div>
        }
      </div>
    </div>

    <ng-template #tooltipTitleTemplate let-data>
      <div class="flex flex-col items-center text-xs mt-0.5">
        <span>{{ data.label }}: {{ data.value | translocoDecimal }} A</span>
      </div>
    </ng-template>
  `,
})
export class PhaseIntensityBarComponent {
  lineIntensity = input.required<number>();
  intensityPhaseR = input.required<number>();
  intensityPhaseS = input.required<number>();
  intensityPhaseT = input.required<number>();

  private phaseR = computed(
    () => (this.intensityPhaseR() / this.lineIntensity()) * 100,
  );
  private phaseS = computed(
    () => (this.intensityPhaseS() / this.lineIntensity()) * 100,
  );
  private phaseT = computed(
    () => (this.intensityPhaseT() / this.lineIntensity()) * 100,
  );

  private phaseSR = computed(() => this.phaseS() + this.phaseR());

  phases = computed(() => [
    { label: 'R', value: this.intensityPhaseR(), width: this.phaseR(), left: 0, bgClass: 'bg-phase-3' },
    { label: 'S', value: this.intensityPhaseS(), width: this.phaseS(), left: this.phaseR(), bgClass: 'bg-phase-1' },
    { label: 'T', value: this.intensityPhaseT(), width: this.phaseT(), left: this.phaseSR(), bgClass: 'bg-phase-2' },
  ]);
}
